import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';
import { Product, Treatment } from './index';

export default class Visit {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		if (Array.isArray(args.appointmentSaleItems)) {
			args.treatments = args.appointmentSaleItems.filter(asi => asi.ItemType === 0);
			args.products = args.appointmentSaleItems.filter(asi => asi.ItemType === 1);
		}
		this.donations = args.donations || [];
		this.appointmentId = args.appointmentId || args.timebokBesokId || null;
		this.chainId = args.chainId || 0;
		this.chainName = args.chainName || '';
		this.comment = args.comment || '';
		this.conditions = args.conditions || '';
		this.currentBonuspoints = args.currentBonuspoints || args.bonusPointsLeft || 0;
		this.customerId = args.customerId || '';
		this.customerName = args.customerName || '';
		this.dateAndTime = moment(args.dateAndTime || args.appointmentTime || '');
		this.employeeId = args.employeeId || '';
		this.employeeImageUrl = args.employeeImageUrl || '';
		this.employeeName = args.employeeName || args.employeeFirstName || '';
		this.fixItSiteId = args.fixItSiteId || '';
		this.isHistoric = !!args.isHistoric;
		this.isLockedOnEmployee = !!args.isLockedOnEmployee;
		this.isRateable = !!(args.isRateable || args.canRate);
		this.products = (args.products || []).map(product => new Product(product));
		this.rating = args.rating || 0;
		this.ratingAnswer = args.ratingAnswer || '';
		this.ratingComment = args.ratingComment || '';
		this.ratingCreatedTime = moment(args.ratingCreatedTime || '');
		this.siteId = args.siteId || 0;
		this.siteName = args.siteName || '';
		this.totalDurationInMinutes = args.totalDurationInMinutes || 0;
		this.totalPrice = args.totalPrice || 0;
		this.treatments = (args.treatments || []).map(treatment => new Treatment(treatment));
		this.visitBonuspointsChange = args.bonusPointBalanceChange || 0;
		this.visitBonuspointsEarned = args.visitBonuspointsEarned || args.bonusPointsEarned || 0;
		this.visitBonuspointsUsed = args.visitBonuspointsUsed || args.bonusPointsUsed || 0;
		this.visitId = args.visitId || '';
		this.visitIdUrlFriendly = args.visitIdUrlFriendly || '';
		this.cancellationHours = args.cancellationHours || 0;
		this.postNo = args.postNo || '';
		this.postArea = args.postArea || '';
		this.address = args.address || '';
	this.urlFrendlyLink = args.urlFrendlyLink || '';
	}

	getRatingText() {
		return this.rating == 5 ? 'Knallbra.' : this.rating == 4 ? 'Bra.' : this.rating == 3 ? 'Greit.' : this.rating == 2 ? 'Dårlig.' : this.rating == 1 ? 'Elendig.' : '';
	}
}
